import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import { staticImg } from '../utils/media';

export default function ProductGallery({ mainImage, images = [], alt = '' }) {
  const all = [];
  if (mainImage) all.push(mainImage);
  images.forEach((img) => { if (img !== mainImage) all.push(img); });
  const [idx, setIdx] = useState(0);
  const [lightbox, setLightbox] = useState(false);

  if (all.length === 0) return null;

  const active = all[idx];
  const prev = () => setIdx((i) => (i - 1 + all.length) % all.length);
  const next = () => setIdx((i) => (i + 1) % all.length);

  const resolveGallery = (name) => {
    if (!name) return '';
    if (name.startsWith('http') || name.startsWith('/')) return name;
    if (name.startsWith('prod_gallery_')) return `/assets/img/products/${name}`;
    return staticImg(name);
  };

  return (
    <>
      <div>
        {/* Main image */}
        <div className="relative rounded-3xl overflow-hidden border border-white/10 bg-gradient-to-br from-[#141110] to-[#0a090c] aspect-[4/3] group">
          <img src={resolveGallery(active)} alt={alt} className="absolute inset-0 w-full h-full object-cover transition duration-500" />
          {all.length > 1 && (
            <>
              <button onClick={prev} className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 md:w-11 md:h-11 rounded-full bg-black/70 backdrop-blur border border-white/20 flex items-center justify-center text-white opacity-100 md:opacity-0 md:group-hover:opacity-100 hover:bg-[#e4b44e] hover:text-[#17140b] transition z-10">
                <ChevronLeft className="w-5 h-5" />
              </button>
              <button onClick={next} className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 md:w-11 md:h-11 rounded-full bg-black/70 backdrop-blur border border-white/20 flex items-center justify-center text-white opacity-100 md:opacity-0 md:group-hover:opacity-100 hover:bg-[#e4b44e] hover:text-[#17140b] transition z-10">
                <ChevronRight className="w-5 h-5" />
              </button>
            </>
          )}
          <button onClick={() => setLightbox(true)} className="absolute bottom-3 right-3 px-3 py-1.5 rounded-full bg-black/70 backdrop-blur border border-white/20 text-xs text-white/80 hover:text-[#f4d896] transition z-10">
            {idx + 1} / {all.length}
          </button>
        </div>

        {/* Thumbnails */}
        {all.length > 1 && (
          <div className="mt-4 grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-2">
            {all.slice(0, 16).map((img, i) => (
              <button key={i} onClick={() => setIdx(i)} className={`relative aspect-square rounded-xl overflow-hidden border-2 transition ${i === idx ? 'border-[#e4b44e]' : 'border-white/8 hover:border-white/30'}`}>
                <img src={resolveGallery(img)} alt={`${alt} ${i + 1}`} className="absolute inset-0 w-full h-full object-cover" />
              </button>
            ))}
            {all.length > 16 && (
              <div className="aspect-square rounded-xl border border-white/8 bg-white/[0.03] flex items-center justify-center text-xs text-white/60 font-semibold">+{all.length - 16}</div>
            )}
          </div>
        )}
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4" onClick={() => setLightbox(false)}>
          <button onClick={() => setLightbox(false)} className="absolute top-6 right-6 w-12 h-12 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white hover:bg-white/20 transition z-10">
            <X className="w-5 h-5" />
          </button>
          {all.length > 1 && (
            <>
              <button onClick={(e) => { e.stopPropagation(); prev(); }} className="absolute left-6 top-1/2 -translate-y-1/2 w-14 h-14 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white hover:bg-[#e4b44e] hover:text-[#17140b] transition z-10">
                <ChevronLeft className="w-6 h-6" />
              </button>
              <button onClick={(e) => { e.stopPropagation(); next(); }} className="absolute right-6 top-1/2 -translate-y-1/2 w-14 h-14 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white hover:bg-[#e4b44e] hover:text-[#17140b] transition z-10">
                <ChevronRight className="w-6 h-6" />
              </button>
            </>
          )}
          <img src={resolveGallery(active)} alt={alt} onClick={(e) => e.stopPropagation()} className="max-w-[92vw] max-h-[88vh] object-contain" />
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 px-4 py-2 rounded-full bg-white/10 border border-white/20 text-sm text-white/80">{idx + 1} / {all.length}</div>
        </div>
      )}
    </>
  );
}
